module.exports = __webpack_public_path__ + "static/media/carret.c1a16dd3.svg";